import { STORAGE_KEYS } from "../config.js";

/** Audio preferences shared by the sound effects and the radio. Persisted per browser. */

type Listener = () => void;
const listeners = new Set<Listener>();

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Preferences are a convenience; private windows may refuse storage.
  }
}

const DEFAULT_RADIO_VOLUME = 0.6;

function readVolume(): number {
  const raw = read(STORAGE_KEYS.radioVolume);
  const value = raw === null ? Number.NaN : Number(raw);
  return Number.isFinite(value) ? Math.min(1, Math.max(0, value)) : DEFAULT_RADIO_VOLUME;
}

let muted = read(STORAGE_KEYS.muted) === "1";
let radioVolume = readVolume();

export const audioPrefs = {
  isMuted(): boolean {
    return muted;
  },

  /** Toggle mute for all game audio (M); returns the new state. */
  toggleMuted(): boolean {
    muted = !muted;
    write(STORAGE_KEYS.muted, muted ? "1" : "0");
    for (const listener of listeners) listener();
    return muted;
  },

  radioVolume(): number {
    return radioVolume;
  },

  setRadioVolume(volume: number): void {
    radioVolume = Math.min(1, Math.max(0, volume));
    write(STORAGE_KEYS.radioVolume, String(radioVolume));
    for (const listener of listeners) listener();
  },

  onChange(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
